<div class="fixed bottom-4 left-1/2 -translate-x-1/2 px-6 py-4 rounded-[12px] max-w-[400px] text-sm font-medium text-center transition-all duration-300 inter-500 {{ currentToast.classes }} {{ !currentToast.isOpen ? 'opacity-0 pointer-events-none translate-y-4' : 'opacity-100' }}">
    <p class="message">{{ currentToast.message }}</p>
</div>
